export var APPS;
(function (APPS) {
    APPS["BULK_ORDER"] = "bulk_order";
    APPS["FLEET_ORDER"] = "fleet_order";
    APPS["URBAN_ORDER"] = "fleet_portal";
    APPS["CORE_PROFILE"] = "core_profile";
    APPS["CENTRAL"] = "central";
    APPS["DEALER_PROFILE"] = "dealer_profile";
    APPS["MECHANICAL_CARE"] = "mechanical_care";
    APPS["ONCALL"] = "oncall";
    APPS["LIVE_TRACK"] = "live_track";
    APPS["CATALOG"] = "catalog";
    APPS["MONITOR"] = "maestro_monitor";
    APPS["FLEET_PORTAL"] = "fleet_portal";
    APPS["REPORTING_DASHBOARD"] = "reporting_dashboard";
    APPS["DTSM"] = "dtsm";
    APPS["GENERIC_FRONT_END_APP"] = "front_end_app";
    APPS["METRICS"] = "Metrics";
})(APPS || (APPS = {}));
//# sourceMappingURL=Apps.js.map